import { render, staticRenderFns } from "./ButtonClose.vue?vue&type=template&id=af4932e2&"
import script from "./ButtonClose.vue?vue&type=script&lang=js&"
export * from "./ButtonClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/spee2/www/univers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af4932e2')) {
      api.createRecord('af4932e2', component.options)
    } else {
      api.reload('af4932e2', component.options)
    }
    module.hot.accept("./ButtonClose.vue?vue&type=template&id=af4932e2&", function () {
      api.rerender('af4932e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/button-close/ButtonClose.vue"
export default component.exports